<template>
  <div>
    <div style="font-size: 10pt;">
      The Diabetes Coalition is NOT a medical provider, and we are providing screenings for diabetes risk factors.  We will NOT provide a diagnosis today.  However, we will give you information about available services in our community that may be able to help you stay or become healthy.  You are not required to give us your name or email address unless you are interested in seeking further assistance in locating a healthcare provider.  The Diabetes Coalition is an NCS (Non-Covered Entity) under HIPAA law in accordance with the publication: Examining Oversight of the Privacy & Security of Health Data Collected by Entities Not Regulated by HIPAA; U.S. Department of Health and Human Services; 200 Independence Avenue, S.W. Washington, DC 20201, June 2016.
    </div>
    <br>
      <b-row class="justify-content-md-center">    
        <b-form>
          <b-row>
            <b-col md="4">
              <label>Screening Date:</label>
            </b-col>
            <b-col md="5">
              <h5>{{ screendate }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Screening Location:</label>
            </b-col>
            <b-col md="5">
                <h5>{{ location }}</h5>
            </b-col>
          </b-row>
          <hr />
          <h5>Please enter your information</h5>
          <b-row>
            <b-col md="4">
              <Label>Volunteer Name:</label>
            </b-col>
            <b-col md="5">
              <b-form-input v-model="$v.volunteerName.$model" :state="volunteerNameState"></b-form-input>
              </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <Label>Volunteer Email:</label></b-col>
            <b-col md="5">
              <b-form-input v-model="$v.volunteerEmail.$model" :state="volunteerEmailState"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <Label>Volunteer Phone:</label></b-col>
            <b-col md="5">
              <b-form-input v-model="$v.volunteerPhone.$model" :state="volunteerPhoneState"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <Label>iPad Name Used to Complete Survey:</label></b-col>
            <b-col md="5">
              <b-form-input v-model="$v.volunteerIpad.$model" :state="volunteerIpadState"></b-form-input>
            </b-col>
          </b-row>
          <!-- <hr />
            <h5>Enter the reference code for this survey</h5>
          <b-row>
            <b-col md="12">
              <label>The reference code should consist of the first 3 letters of the respondant's last name, DOB month, and DOB day</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Reference Code:</label>
            </b-col>
            <b-col md="5">
                <b-form-input id="txtReferenceCode" v-model="$v.referenceCode.$model" :state="referenceCodeState" ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8" offset="2" >
              <label>Example: Mr. Smith born on May 25th should be entered as: SMI0525</label>
            </b-col>
          </b-row> -->
        </b-form>
      </b-row>          
    <b-row>
      <b-col>
        <b-button  variant="primary" size="lg" @click="SetName">Start Survey</b-button>
      </b-col>
    </b-row>
    <b-row>
        <b-col sm="12">
          <div v-if="showErrorMsg">             
            <font-awesome-icon icon="exclamation-triangle" class="fa-2x"/>   
            <span class="error-message">All fields are required!</span>
            </div>
        </b-col>
    </b-row>

  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { format } from "path";
library.add(fas)

export default {
  name: "VolunteerPin",
  props: ["location", "surveyData"],
  components: {
    FontAwesomeIcon
  },
  data: () => ({
    screendate: new Date().toJSON().slice(0,10).replace(/-/g,'/'),
    volunteerName: "",
    volunteerEmail: "",
    volunteerPhone: "",
    volunteerIpad: "",
    //referenceCode: null,
    isInvalid: true,
    showErrorMsg: false
  }),
  validations: {
    volunteerName: {
      required
    },
    volunteerPhone: {
      required
    },    
    volunteerEmail: {
      required
    },
    volunteerIpad: {
      required
    },
    // referenceCode: {
    //   required
    // }
  },
  methods: {
    SetName() {
      if (!this.$v.$invalid) {
        this.$emit("move-next", {
          name: this.volunteerName,
          phone: this.volunteerPhone,
          email: this.volunteerEmail,
          ipad: this.volunteerIpad,
          //referenceCode: this.referenceCode,
          isValid: true
        });
        this.referenceCode = null; //reset the value to null for the next survey
      } else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }

    },
    onCreated() {
      this.volunteerName = this.surveyData.VolunteerName;
      this.volunteerEmail = this.surveyData.VolunteerEmail;
      this.volunteerPhone = this.surveyData.VolunteerPhone;
      this.volunteerIpad = this.surveyData.VolunteerIpad;
    }
  },
  computed: {
    
    volunteerNameState () {
      return this.$v.volunteerName.$dirty ? this.$v.volunteerName.required : null;
    },    
    volunteerEmailState () {
      return this.$v.volunteerEmail.$dirty ? this.$v.volunteerEmail.required : null;
    },    
    volunteerPhoneState () {
      return this.$v.volunteerPhone.$dirty ? this.$v.volunteerPhone.required : null;
    },
    volunteerIpadState () {
      return this.$v.volunteerIpad.$dirty ? this.$v.volunteerIpad.required : null;
    },
    // referenceCodeState () {
    //   return this.$v.referenceCode.$dirty ? this.$v.referenceCode.required : null;
    // }
  },
  watch: {
  //  referenceCode() {
  //    if(this.referenceCode != undefined && this.referenceCode != null && this.referenceCode != '')
  //       this.referenceCode = this.referenceCode.toUpperCase();
  //   }
  },
  created() {
    this.onCreated();
  }
};
</script>

<style scoped>
.row{
  padding-bottom: 10px;
}
.fa-exclamation-triangle{
  color: red;
}
.error-message{
  color: red;
  font-size: 1.5em;
  padding-left: 10px;
}
</style>